import { css } from "@emotion/react";
import { type StatusDotProps } from "./types";

/** Maps intent to its design-token CSS variable name. Not always
 * `--color-${intent}` — "error" maps to --color-danger, since the
 * design token uses a different name than the intent. */
const INTENT_COLOR_VAR: Record<StatusDotProps["intent"], string> = {
  success: "--color-success",
  info: "--color-info",
  warning: "--color-warning",
  error: "--color-danger"
};

/**
 * Glowing circle indicating a status, with color determined by the `intent` prop.
 */
function StatusDot({ intent }: StatusDotProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6px"
      height="6px"
      viewBox="0 0 6 6"
      aria-hidden="true"
      focusable="false"
      className={`kit-StatusDot ${intent}`}
      fill="var(--status-dot-color)"
      css={[
        css`
          --status-dot-color: var(${INTENT_COLOR_VAR[intent]});
          filter: drop-shadow(0px 0px 2px var(--status-dot-color));
        `
      ]}
    >
      <circle cx="3" cy="3" r="3" />
    </svg>
  );
}

export default StatusDot;
